import { Button, ListItem, ListItemAvatar, ListItemIcon, ListItemText, Tooltip } from "@material-ui/core";
import React, { useEffect, useState, useRef, useMemo } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

export const gridVideoframeOptions = {
  width: "100%",
  height: "100%",
  insertMode: "append",
  showControls: false,
};

export default function VonageGridView(props) {
  const [videoCount, setVideoCount] = useState(0);
  const [gridClass, setGridClass] = useState("one-row");
  const [currentlyShown, setCurrentlyShown] = useState([]);
  const [maxCountToShow, setMaxCountToShow] = useState(9);
  const functionsRef = useRef();
  const { orderList } = props;
  useEffect(() => {
    if (props.publisher && props.publisher.stream) {
      if (props.streams.length + 1 != videoCount) {
        setVideoCount(props.streams.length + 1);
        calculateColumns(props.streams.length + 1);
      }
    } else {
      if (props.streams.length != videoCount) {
        setVideoCount(props.streams.length);
        calculateColumns(props.streams.length);
      }
    }
    functionsRef.current = {
      onStreamConnected,
      setNewPersonTalking,
      onStreamDisconnected,
      toggleGridView,
    };
  });
  useEffect(() => {
    props.setFunctionsRef(functionsRef);
  }, []);
  const hiddenSpeakers = useMemo(() => {
    let hidden = [];
    props.streams.map((s) => {
      if (!currentlyShown.find((cs) => cs.stream?.id === s.stream?.id)) hidden.push(s);
    });
    if (props.publisher && props.publisher.stream && !currentlyShown.find((cs) => cs.stream?.id === props.publisher.stream?.id)) {
      hidden.push(props.publisher);
    }
    return hidden;
  }, [currentlyShown.length, props.streams.length, props.publisher]);

  function calculateColumns(vids) {
    if (vids <= 1) {
      setGridClass("one-row-single");
    } else if (vids == 2) {
      setGridClass("one-row");
    } else if (vids > 2 && vids < 5) {
      setGridClass("two-row");
    } else if (vids >= 5 && vids < 10) {
      setGridClass("three-row");
    } else if (vids >= 10 && vids < 13) {
      setGridClass("three-row wide");
    } else if (vids >= 13 && vids < 17) {
      setGridClass("four-row");
    } else if (vids >= 17 && vids < 21) {
      setGridClass("four-row wide");
    } else if (vids >= 21 && vids < 26) {
      setGridClass("five-row");
    } else if (vids >= 26 && vids < 31) {
      setGridClass("five-row wide");
    } else if (vids >= 31 && vids < 37) {
      setGridClass("six-row");
    } else if (vids >= 37 && vids < 43) {
      setGridClass("six-row wide");
    } else if (vids >= 43 && vids < 50) {
      setGridClass("seven-row");
    } else {
      setGridClass("seven-row wide");
    }
  }
  function toggleGridView() {
    const containerDiv = document.getElementById("vonage-grid-container");
    for (const subscriber of currentlyShown) {
      containerDiv.append(subscriber.element);
      if (typeof subscriber.subscribeToVideo == "function") {
        subscriber.subscribeToVideo(true);
        setTimeout(() => subscriber.subscribeToVideo(true), 500);
        setTimeout(() => subscriber.subscribeToVideo(true), 1000);
      }
    }
  }
  function onStreamConnected(subscriber) {
    if (currentlyShown.length < maxCountToShow) {
      currentlyShown.push(subscriber);
      const containerDiv = document.getElementById("vonage-grid-container");
      if (props.layoutMode == "grid") {
        containerDiv.append(subscriber.element);
        if (typeof subscriber.subscribeToVideo == "function") {
          subscriber.subscribeToVideo(true);
          setTimeout(() => subscriber.subscribeToVideo(true), 500);
          setTimeout(() => subscriber.subscribeToVideo(true), 1000);
        }
      }
    } else if (props.layoutMode == "grid") {
      if (typeof subscriber.subscribeToVideo == "function") {
        subscriber.subscribeToVideo(false);
      }
    }

    // 10, length
  }
  function onStreamDisconnected(subscriber) {
    let subscriberToRemove = currentlyShown.find((s) => s.widgetId == subscriber.widgetId);
    if (subscriberToRemove) {
      const containerDiv = document.getElementById("vonage-grid-container");
      const hiddenDiv = document.getElementById("vonage-grid-hidden");

      currentlyShown.splice(currentlyShown.indexOf(subscriberToRemove), 1);

      if (hiddenDiv.firstChild) {
        if (props.publisher && props.publisher.element == hiddenDiv.firstChild) {
          currentlyShown.push(props.publisher);
          if (props.layoutMode == "grid") {
            containerDiv.append(props.publisher.element);
          }
        } else {
          var newStream = props.streams.find((x) => x.element == hiddenDiv.firstChild);
          if (newStream) {
            currentlyShown.push(newStream);
            if (props.layoutMode == "grid") {
              containerDiv.append(newStream.element);
              if (typeof newStream.subscribeToVideo == "function") {
                newStream.subscribeToVideo(true);
                setTimeout(() => newStream.subscribeToVideo(true), 500);
                setTimeout(() => newStream.subscribeToVideo(true), 1000);
              }
            }
          }
        }
      }
    }
  }

  function setNewPersonTalking(subscriber) {
    const containerDiv = document.getElementById("vonage-grid-container");
    const hiddenDiv = document.getElementById("vonage-grid-hidden");
    if (currentlyShown.indexOf(subscriber) != -1) {
      return;
    } else if (currentlyShown.length >= maxCountToShow) {
      currentlyShown.unshift(subscriber);
      let subToRemove = currentlyShown.pop();
      if (props.layoutMode == "grid") {
        if (typeof subscriber.subscribeToVideo == "function") {
          subscriber.subscribeToVideo(true);
          setTimeout(() => subscriber.subscribeToVideo(true), 500);
          setTimeout(() => subscriber.subscribeToVideo(true), 1000);
        }
        if (typeof subToRemove.subscribeToVideo == "function") {
          subToRemove.subscribeToVideo(false);
        }
        containerDiv.prepend(subscriber.element);
        hiddenDiv.prepend(subToRemove.element);
      }
    } else {
      currentlyShown.unshift(subscriber);
      if (props.layoutMode == "grid") {
        containerDiv.prepend(subscriber.element);
        if (typeof subscriber.subscribeToVideo == "function") {
          subscriber.subscribeToVideo(true);
          setTimeout(() => subscriber.subscribeToVideo(true), 500);
          setTimeout(() => subscriber.subscribeToVideo(true), 1000);
        }
      }
    }
  }

  return (
    <div id="vonage-grid-wrap" style={{ display: props.layoutMode == "grid" ? "flex" : "none" }}>
      <div className={gridClass} id={"vonage-grid-container"}>
        {hiddenSpeakers.length > 0 ? <HiddenSpeakerlist orderList={orderList} hiddenSpeakers={hiddenSpeakers} showSpeaker={setNewPersonTalking} /> : null}
      </div>
      <div ref={(r) => props.setGridViewHiddenRef(r)} id="vonage-grid-hidden" style={{ display: "none" }}></div>
    </div>
  );
}

const HiddenSpeakerlist = ({ hiddenSpeakers = [], showSpeaker, orderList }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        startIcon={<span>{hiddenSpeakers.length}</span>}
        endIcon={Boolean(anchorEl) ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
        aria-controls="simple-menu"
        aria-haspopup="true"
        style={{
          borderRadius: "5px",
          background: "#222222d4",
          padding: "4px 20px",
          color: "#fff",
          position: "absolute",
          right: "60px",
          bottom: "20px",
          zIndex: 100,
        }}
        onClick={handleClick}
      >
        <SystemLabel name="HiddenSpeakers" />
      </Button>
      <Menu
        PaperProps={{
          style: { background: "#222222fa", color: "#fff" },
        }}
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {hiddenSpeakers.map((h, i) => {
          const order = orderList.find((o) => o.badgeNo === h?.stream?.name);
          return (
            <MenuItem
              key={h.widgetId + `${i}`}
              onClick={() => {
                showSpeaker(h);
                handleClose();
              }}
            >
              <Tooltip title={<SystemLabel name="ShowSpeakerInGrid" />}>
                <ListItem component="span" style={{ padding: 0 }}>
                  <ListItemIcon style={{ minWidth: 35, color: "#eee" }}>
                    <AccountCircleIcon />
                  </ListItemIcon>
                  <ListItemText primary={order ? order.name : h?.stream?.name} />
                </ListItem>
              </Tooltip>
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};
